import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, type, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    const baseClasses = "button";
    const variantClasses = {
      default: "button-default",
      destructive: "button-destructive",
      outline: "button-outline",
      secondary: "button-secondary",
      ghost: "button-ghost",
      link: "button-link",
      gradient: "button-gradient",
      gradientDestructive: "button-gradient-destructive",
    };
    const sizeClasses = {
      default: "button-md",
      sm: "button-sm",
      lg: "button-lg",
      icon: "button-icon",
    };

    return (
      <Comp
        className={cn(
          baseClasses,
          variantClasses[variant] || variantClasses.default,
          sizeClasses[size] || sizeClasses.default,
          className
        )}
        ref={ref}
        type={asChild ? undefined : type || "button"}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };
